import axios, { AxiosError } from "axios"

type response = { error?: string; message?: string }

export const addUserBadge = async (user_id: string, badge_id: string): Promise<response> => {
  try {
    const res = await axios.post<response>(`/user-badges/${user_id}/badges/${badge_id}`)
    return res.data
  } catch (error) {
    return { error: error?.toString(), message: (error as AxiosError)?.response?.data?.message }
  }
}
